// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card___GnI4","content":"Card_content__P_Brk","error":"Card_error__QNMs8","success":"Card_success__einmv","warning":"Card_warning__a_UUH","info":"Card_info__hyfzH"};